import { getCurrentOrganizationId } from './organizationSelectors';

export const getIsLoadingInvitations = (
    state,
    selectedOrganizationId = getCurrentOrganizationId(state),
) =>
    !!state.currentOrganizations.loadingInvitations &&
    !!state.currentOrganizations.loadingInvitations[selectedOrganizationId];

export const getInvitations = (
    state,
    selectedOrganizationId = getCurrentOrganizationId(state),
) => {
    const invitations = state.invitationsByOrg[selectedOrganizationId];
    if (invitations) {
        return invitations.sort((a, b) =>
            a.invitedEmail.localeCompare(b.invitedEmail),
        );
    }
    return undefined;
};



// WEBPACK FOOTER //
// ./src/selectors/organizationInvitationsSelector.js